import { updateInitialParameters } from '../actions/internalActions';
import { getGroupMailboxInfo } from 'owa-group-files-hub-adaptors';
import { updateItemsViewCache } from '../store/cache';
import { getCurrentGroupSmtpAddress } from 'owa-groups-shared-store';

export async function onFilesViewNavigation() {
    updateInitialParameters(getGroupMailboxInfo(getCurrentGroupSmtpAddress()));
    updateItemsViewCache();
}
